import { call, put, takeLeading } from "redux-saga/effects";
import { getAuthToken, USER_LOGIN_SUCCESS } from "../Benutzer";
import { dataLogRawArrived } from "../Datenlog";

import moment from "moment";

function* getBacklogDay(day) {
	const backlog = yield call(fetch, "/backlog/" + day + ".jsonarr", {
		method: "GET",
		headers: {
			"Accept": "text/plain",
			"Authorization": "Bearer " + getAuthToken()
		}
	});
	const payload = yield backlog.text();
	yield put(dataLogRawArrived(payload, day));
	return;
}

export function* watchUserLoginAsync() {
	yield takeLeading(USER_LOGIN_SUCCESS, function* getBacklog() {
		const start = moment();
		const days = [start.format("YYYY-MM-DD")];
		for (let i = 0; i < 8; ++i) {
			days.push(start.subtract(1, "days").format("YYYY-MM-DD"));
		}
		try {
			yield getBacklogDay(days[0]);
			yield getBacklogDay(days[1]);
			yield getBacklogDay(days[2]);
			yield getBacklogDay(days[3]);
			yield getBacklogDay(days[4]);
			yield getBacklogDay(days[5]);
			yield getBacklogDay(days[6]);
			yield getBacklogDay(days[7]);
		}
		catch (e) {
			yield put({type: "DATALOG_FAILED", data: "something failed: " + JSON.stringify(e)});
		}
	});
  }